import { createUserConverter } from "@t3/shared";
import {
  DocumentData,
  FirestoreDataConverter,
  QueryDocumentSnapshot,
  serverTimestamp,
} from "firebase/firestore";
import { UserType } from "@t3/shared";

export const userConverter = createUserConverter<
  DocumentData,
  QueryDocumentSnapshot
>(serverTimestamp) as FirestoreDataConverter<UserType, DocumentData>;
